module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignet.157229d.jpg";